// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"56":"Showcase","176":"Usage","466":"Demo"}[chunkId] + "-legacy." + {"56":"007fd172","176":"b0eecde4","466":"48f3d30b"}[chunkId] + ".js";
};